import * as React from 'react'
import { useIntl } from 'react-intl'
import Head from 'components/Head'
import Link from 'next/link'
import * as Auth from 'contexts/authentication'
import * as Page from 'layouts/pages'
import * as Context from 'layouts/MountainInformationNetwork/submit/contexts/root'
import Form from 'layouts/MountainInformationNetwork/submit/Form'
import { FormattedMessage } from 'react-intl'

export async function getStaticProps({ locale }) {
    return {
        props: {
            schemas: await Context.getSchemas(undefined, locale),
        },
    }
}

export default function Submit({ schemas }) {
    return <Form schemas={schemas} />
}

Submit.getLayout = function getLayout(children, title) {
    return (
        <Page.Layout
            title={
                <Title>
                    {title || (
                        <FormattedMessage
                            description="Layout min/Form"
                            defaultMessage="Mountain Information Network — Create report"
                        />
                    )}
                </Title>
            }>
            {children}
        </Page.Layout>
    )
}

// Utils and consts
function Title({ children }) {
    const username = Auth.useUsername()
    const intl = useIntl()
    const pageTitle = intl.formatMessage({
        description: 'Mountain Information Network — Create Report',
        defaultMessage: 'Mountain Information Network — Create Report',
    })

    return (
        <React.Fragment>
            <Head title={pageTitle} description={pageTitle} />
            {children}
            {username && (
                <small>
                    <FormattedMessage
                        description="Layout min/Form"
                        defaultMessage="Hi, <link></link>"
                        values={{
                            link() {
                                return (
                                    <Link href="/account">
                                        <a>{username}</a>
                                    </Link>
                                )
                            },
                        }}
                    />
                </small>
            )}
        </React.Fragment>
    )
}
